import { lazy, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import logo from '../Images/logo.svg';
import LoginForm from './AuthP/LoginForm';
import CalculatorPage from 'page/CalculatorPage';

const ProductList = lazy(() => import('../components/ProductList/ProductList'));
const HomePage = lazy(() => import('../page/HomePage'));
const AboutAlltenta = lazy(() => import('../page/AboutAlltenta'));
const ContactPage = lazy(() => import('../page/ContactPage'));
const DealerInfoPage = lazy(() => import('../page/DealerInfoPage'));
const BlogPage = lazy(() => import('../page/BlogPage'));
const BlogArticle = lazy(() => import('./BlogArticle/BlogArticle'));
const ProductPage = lazy(() => import('../page/ProductPage'));
// const CalculatorPage = lazy(() => import('../page/CalculatorPage'));
// const LoginForm = lazy(() => import('../components/AuthP/LoginForm'));

const ProtectedRoute = ({ children }) => {
  const authStatus = localStorage.getItem('isAuthenticated');
  console.log(authStatus); // Логируем значение для проверки
  return authStatus === 'true' ? children : <Navigate to="/login" />;
};

export const App = () => {
  return (
    <>
      <Suspense
        fallback={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <img src={logo} alt="Загрузка..." />
          </div>
        }
      >
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/Alltenta" element={<AboutAlltenta />} />
          <Route path="/Contact" element={<ContactPage />} />
          <Route path="/Dealer" element={<DealerInfoPage />} />
          <Route path="/Blog" element={<BlogPage />} />
          <Route path="/Article/:id" element={<BlogArticle />} />
          <Route path="/ProductList/Product/:id" element={<ProductPage />} />
          <Route path="/ProductList/:id" element={<ProductList />} />
          <Route path="/login" element={<LoginForm />} />
          <Route
            path="/Calculator"
            element={
              <ProtectedRoute>
                <CalculatorPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
      </Suspense>
    </>
  );
};
